// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import AppMobile from './AppMobile'
// import App from './AppPublicDemo'
import router from './router'
import ElementUI from 'element-ui'

// import './assets/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/theme-default/app.css'
import './assets/theme-default/main.css'
import './assets/icon/iconfont.css'
import './assets/icontwo/iconfont.css'
import 'babel-polyfill'

import axios from './assets/js/http.js'

import VueAxios from 'vue-axios'

import Ginkgo from './assets/js/Ginkgo.js'
Vue.prototype.Ginkgo = Ginkgo

import global from './assets/Global.vue'
Vue.prototype.global = global

// 显示大图（组件）
import bigImg from './assets/BigImg.vue'
const BigImg = {
  install: function(Vue) {
    Vue.component('BigImg', bigImg)
  }
}
Vue.use(BigImg)

Vue.config.productionTip = false

Vue.use(ElementUI, { size: 'small' })
Vue.use(VueAxios, axios)

import echarts from 'echarts'
Vue.prototype.$echarts = echarts
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

// new Vue({
//   el: '#appMobile',
//   router,
//   template: '<AppMobile/>',
//   components: { AppMobile }
// })
// router.beforeEach((to, from, next) => { // 只有页面切换时才生效，第一次不生效
//   console.log(to.meta.title)
//   console.log(from.meta.title)
//   // console.log(next.meta.title)
//   document.title = to.meta.title || 'GSV1'
//   // if (!to.query.url && from.query.url) {
//   //   to.query.url = from.query.url
//   // }
//   next()
// })
// router.afterEach(function (transition) {
//   if (transition.to.meta.title) {
//     document.title = transition.to.meta.title
//   }
// })



// WEBPACK FOOTER //
// ./src/main.js